var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 380,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 380,
    enableBackground: "new 0 0 823 823",
    viewBox: "0 0 823 823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cce9ff",
    d: "M556.1 64.9C469 7.5 346.6 19.1 269.6 104.3c-42.1 46.6-59.2 110.7-102.9 156.3-49.2 51.4-108 101.3-130.3 171.3-23.7 74.4-2.9 159.7 50.1 216.6 64.5 69.2 159.3 48.4 248.9 47.3C702.3 691.2 975 446.3 628 144.4c-29-25.4-43.1-60.6-71.9-79.5z",
    className: "colorcce9ff svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB9678",
    d: "M585.9 434.9S542 498 497.2 477.5C452.3 457 486 439 486 439s-8.3-17.3 46.1 1.9c25.7 8.9 53.8-6 53.8-6z",
    className: "colorffbe55 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M532.4 240.2s42.5 50-14.3 119.1c-56.8 69.2-48 105.8-48 105.8s-79.2-120.3 62.3-224.9z",
    className: "color0e538c svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#25B39E",
    d: "M478.5 461.9c-26.4 5.3-5-71.6 34.6-95 39.7-23.4 75.1-25.7 97.4-48.3 0 0-1.8 117-132 143.3z",
    className: "color2a94f4 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbe55",
    d: "M652.2 912.4c12.6-20.9 22-43.2 28.1-66.2l49.8-9.5.5-55.1.5-55.1-49.5-10.5c-5.7-23.1-14.7-45.6-26.9-66.7l28.4-41.9-38.6-39.3-38.5-39.3-42.4 27.6c-20.9-12.6-43.2-22-66.2-28.1l-9.5-49.8-55.1-.5-55.1-.5-10.5 49.6c-23.1 5.7-45.6 14.7-66.7 26.9l-41.9-28.4-39.3 38.6-39.3 38.5 27.6 42.4c-12.6 20.9-22 43.2-28.1 66.2l-49.8 9.5-.5 55.1-.5 55.1 49.6 10.5c5.7 23.1 14.7 45.6 26.9 66.7l-28.4 41.9 38.6 39.3 38.6 39.3 42.4-27.6c20.9 12.6 43.2 22 66.2 28.1l9.5 49.8 55.1.5 55.1.5 10.5-49.6c23.1-5.7 45.6-14.7 66.7-26.9l41.9 28.4 39.3-38.6 39.3-38.6-27.8-42.3zm-318.6-39.1c-52.2-53.2-51.4-138.7 1.8-190.9 53.2-52.2 138.7-51.4 190.9 1.8 52.2 53.2 51.4 138.7-1.8 190.9-53.2 52.2-138.7 51.4-190.9-1.8z",
    className: "colorffbe55 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M531 582.3s9.8 16.6 13.9 19.3c5.6 3.7 2.1 7.4-.6 7.4s-16.2 1-19.2-2.4-4.5-13.6-7.3-16.2c-2.8-2.7-5.7-13.2 1.4-15.8 6.2-2.4 11.8 7.7 11.8 7.7z",
    className: "color0e538c svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3ca",
    d: "M526.8 575s11.2 19.4 13.1 22.3c1.9 2.9-3.6 2.9-7.1 1.5-3.4-1.4-12.1-15.3-13.4-17.8-1.5-3-.3-6.5-.3-6.5l7.7.5z",
    className: "colorffe3ca svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "m515.4 585.5 2.6 19.8 1.4.1-.4-14.3zM435.2 589.3s9.8 16.6 13.9 19.3c5.6 3.7 2.1 7.4-.6 7.4s-16.2 1-19.2-2.4-4.5-13.6-7.3-16.2c-2.8-2.7-5.8-13.5 1.4-15.8 6.2-2.1 11.8 7.7 11.8 7.7z",
    className: "color0e538c svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3ca",
    d: "M431.5 582.1s10.6 19.3 12.5 22.2c1.9 2.9-3.6 2.9-7.1 1.5-3.4-1.4-12.1-15.3-13.4-17.8-1.5-3-.3-6.5-.3-6.5l8.3.6z",
    className: "colorffe3ca svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "m419.6 592.5 2.6 19.8 1.3.1-.4-14.3z",
    className: "color0e538c svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3ca",
    d: "m391.8 438.6 88.4 40.3s9.9 3.2 11 14.2c3.4 34.2 29 88.4 29 88.4 8.2 4 7.6.5 7.6.5-5.2-16.6-11.5-85-13.7-112.5-.5-5.8-.8-9.8-.8-11.1 0-.9-1-2-2.6-3.3-12.1-9.8-62-30.2-62-30.2-37.6-1-56.9 13.7-56.9 13.7z",
    className: "colorffe3ca svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3ca",
    d: "M375.2 455.9c2.7 23.9 36.8 21.2 36.8 21.2h41.3s-10.9 24.2-15 44.5c-4.4 21.6-14.9 59.9-14.9 59.9s.7 1.3 8.2.6c0 0 32.4-64.7 44.9-80.9 2.7-3.5 10.3-22.5 11.6-33.8.4-3.8.2-6.8-1.3-7.9-1.4-1.2-4.7-3.5-9.1-6.2-12.9-8.2-35.4-20.7-48-23.5-16.8-3.8-43.3-10.8-43.3-10.8s-14 13-11.2 36.9z",
    className: "colorffe3ca svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M403.3 271.9s-6.2-11.7-3.2-24.3c3-12.5 14.6-25 31.6-19.2 17 5.7 30.7 18.9 20.5 34.2-10.2 15.3 9.2 22.2 4.3 29.4-4.9 7.3-3.1 14.8-1 16.5 2.1 1.7 8.8 7.7 8.1 14.8-.7 7.1-33-20.8-33-20.8s-17.4-35.1-27.3-30.6z",
    className: "color0e538c svgShape"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb4747",
    d: "M455.1 422s-2.6 12.4-68.6-3.3c0 .1 22.1-7.3 68.6 3.3z",
    className: "coloreb4747 svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M385.8 422.3c-1 2-2 3.9-3.1 5.9l72.4 2.1c-3.8-12.8-2.6-30.1-1.9-43.2.8-16 9.7-27.2 8.7-43.4 4.8.8 5.6.9 10.4 1.7-7.3-20.8-9.8-31.2-32.5-39.2-7.4-2.6-12.3-3.1-20.3-2.5-26.3 2.2-34.2 2.5-47.2 26.3 20.2 3.2 16.9 10.5 23 30.6 3 9.8 6.1 20.8 4.5 31.1-1.5 10.1-14 21.3-14 30.6z",
    className: "colorfff svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3ca",
    d: "M427.7 311.1c-10.8-2-8.5-8-8.5-8s.5-3.4.7-7.7c.1-1.1.1-2.2.1-3.4 0-1.8-.1-3.6-.3-5.3-.9-7.2 19.5-2.9 19.5-2.9s-1.2 14.6 1.6 19c2.9 4.4-2.3 10.3-13.1 8.3z",
    className: "colorffe3ca svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3ca",
    d: "M407.2 303s21.7 25.1 29.7 30.9c0 0 9.2-8.3 3.5-30.3.1 0-10.4-5.3-33.2-.6zM407.8 242.7s-11.3 21.7-.1 42.3c11.2 20.6 33.2-9 34.6-12.4 1.4-3.5 9-23.1-6-29-15-6-25.3-6.8-28.5-.9z",
    className: "colorffe3ca svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M411.5 250.4s-7.8 10.2-8.7 17.7c0 0-3.1-14.2 5.6-27.9s31-.7 33.9 4.8c3 5.5 11.7 10.3-3 33.8.2 0-26.2-18.3-27.8-28.4z",
    className: "color0e538c svgShape"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd2b1",
    d: "M429.6 287.2s-2 4.3-9.6 8.3c.1-1.1.1-2.2.1-3.4-.1-.1 5.1-.7 9.5-4.9z",
    className: "colorfcd2b1 svgShape"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3ca",
    d: "M315.6 402.7s-5.4 2.4-7.9 1.3c-2.5-1.1-6.5-1.3-7.7-1.3-1.7 0-6.8-1.9-6.8.2.1 2 8.4 3.4 10.1 4.1 1.7.6-5.1 4.4-5.7 6-.6 1.7 7.1 12.6 11.4 9.5 4.3-3.1 6.7-9.3 7.6-9.7.9-.4 3.3-2.1 3.3-2.1l-4.3-8z",
    className: "colorffe3ca svgShape"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe3ca",
    d: "M298.4 412s-12.6 10.4-12.8 11.8c-.2 1.4.5 2.1 1.7 1.1 1.2-.9 12.5-9.7 12.5-9.7s-12.6 14.9-13 16c-.2.6 1 2 1.7 1.6.7-.4 14.1-14.4 14.1-14.4s-11.7 13.9-11.8 15c-.1.9 1.4 1.9 2.3.9.9-1 12.6-13.2 12.6-13.2s-7.9 10.7-7.4 11.6c.3.6 1.3 1.8 3.2-1 1.9-2.8 7.2-9 7.2-9L298.4 412z",
    className: "colorffe3ca svgShape"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#254368",
    d: "M449 477.1h-37s-34.1 2.7-36.8-21.2c-2.7-23.9 11.2-37.2 11.2-37.2s18 4.8 33.7 8.6c7.9-1.7 17.4-2.8 28.4-2.5 0 0 66.7 22 64.7 33.6 0 .1-27.9-14.8-64.2 18.7z",
    className: "color254368 svgShape"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m424.9 435.7 70.6-1-35.6 18.1z",
    className: "colore6e6e6 svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#25B39E",
    d: "M446.9 426.7s-15.9 6.1-35.3.6l-.9-7.3 40.1 2.2-3.9 4.5z",
    className: "color2a94f4 svgShape"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "m459.9 452.8-35-13.6v-3.5l37.7 13.6z",
    className: "colorf2f2f2 svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB9678",
    d: "M446.6 430.1c-.2 2.6 2.4 4.5 4.9 3.5l4.1-1.8c1.2-.5 1.9-1.8 1.7-3.1-1.7-10.7-5.4-52.2 0-59.4 2-2.6 3.2-4.9 3.9-7 3.5 9.1 7.9 20.8 9.7 27.1l33.3 44.4 11.2 2.8c-13.9-33.6-25.2-51.4-25.2-51.4-2.2-5.9-8.4-23.6-14-39.4-3.5-10-6.7-19.2-8.4-24.1-.9-2.5-2.6-4.6-4.9-6-5.2-3.1-13.8-8-21.6-11.7h-.1c-.2-.1-.5-.2-.7-.4 14.8 22.4 9 85.8 6.1 126.5 0-.1 0-.1 0 0zM391.5 305.5c-4.8.7-16.5 12.2-22.8 23.7-7.1 13.2-14.4 28.2-19.9 33.1-10 9.1-38.1 41.2-39.4 40.4-.5-.3 7.7 9.6 8.7 10 .5.2 46.1-39.3 50.5-45.3 4.2-5.7 15.3-29.6 18.6-29.1.3.5 4.3 9.3 8.1 22.1.1.2.1.4.2.6 2.6 8.9 2.4 18.6 1 29.5-1.1 8.2-7.2 21.7-10.9 28.2-.4.8-.3 2.3.1 3.4.3.7.7 1.2 1.2 1.4l13.4 5 3.1 1.2c2.3.8 4.6.4 6.4-.9 1.5-1.1 2.5-2.7 2.8-4.6 3-22.9 6.7-46.3 9.7-55.1 13.2-38.7-5.1-67.7-5.1-67.7s-21.5 2.5-25.7 4.1z",
    className: "colorffbe55 svgShape"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "m459.9 452.8 21-57.3 67.6 1.1-20 52.8z",
    className: "colorf2f2f2 svgShape"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M502.5 420.8c-2.1 4.1-1.4 8.6 1.4 10 2.8 1.4 6.8-.8 8.9-4.9 2.1-4.1 1.4-8.6-1.4-10-2.9-1.4-6.8.8-8.9 4.9z",
    className: "colord3d3d3 svgShape"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M431.2 264.3s4.3 6.7.3 12.6c-4 5.8 1 11.5 1.9 17.7.9 6.2-16.7 22.5 2.8 30.8 19.6 8.2 25.8-5.4 20.8-12.9s-8.5-13.6-9-24.3c-.4-10.7-3.9-27.3-16.8-23.9z",
    className: "color0e538c svgShape"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB9678",
    d: "M653.9 449.3V462l13.7-12.7h53.3c3.4 0 6.1-2.9 6.1-6.4v-79.7c0-3.5-2.7-6.4-6.1-6.4h-85.3c-3.4 0-6.1 2.9-6.1 6.4v79.7c0 3.5 2.7 6.4 6.1 6.4H653.9z",
    className: "colorffbe55 svgShape"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M705.6 430.1v-3.2c0-10.6-8.2-19.1-18.3-19.1H669c-10.1 0-18.3 8.6-18.3 19.1v3.2h54.9zM690.4 385.5c0 7-5.5 12.7-12.2 12.7-6.7 0-12.2-5.7-12.2-12.7 0-7 5.5-12.8 12.2-12.8 6.7.1 12.2 5.8 12.2 12.8z",
    className: "colorfff svgShape"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB9678",
    d: "M268.1 351.5c0 5-3.9 9-8.6 9h-5.7v21.1l-20.1-21.1h-66.1c-4.8 0-8.6-4-8.6-9v-75.2c0-5 3.9-9 8.6-9h92c4.8 0 8.6 4 8.6 9v75.2z",
    className: "colorffbe55 svgShape"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce9ff",
    d: "M176.2 294.4h74.7v6h-74.7zM176.2 309.4h74.7v6h-74.7zM176.2 324.5h74.7v6h-74.7z",
    className: "colorcce9ff svgShape"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbe55",
    d: "M248.4 211.2c12.8-10.6 20.2-25.3 21.2-42.4.1-1.1.1-2.1.1-3.2.1-6.6-.7-12.2-2.5-18.4-.1-.2-.1-.3-.2-.5 0 .2.1.3.2.5l-16.8 5.4c1.2 4 1.8 8.3 1.8 12.8-.2 13.7-6.7 25.7-16.7 33.1l10.1 15c.9-.8 1.9-1.5 2.8-2.3z",
    className: "color0e538c svgShape"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce9ff",
    d: "M180.6 188.5c-4.6-6.9-7.3-15.3-7.2-24.3.3-22.8 18.2-40.9 39.9-40.6 17.5.3 32.1 12.4 37 29l16.8-5.4c0-.2-.1-.3-.2-.5-.2-.7-.5-1.5-.7-2.2-.1-.2-.1-.4-.2-.6-8-22.5-27.2-37.3-50.1-38.6-.5 0-1.1 0-1.6-.1h-3.8c-.6 0-1.2.1-1.8.1-.4 0-.8.1-1.2.1-.3 0-.7.1-1 .1-.7.1-1.4.2-2 .3h-.1c-4.9.8-9.5 2.2-13.9 4.1-.5.2-1.1.5-1.6.7-17.5 8.5-30.2 26-32.5 47v.4c-.1.7-.1 1.4-.2 2.1 0 .4-.1.7-.1 1.1 0 .5 0 1-.1 1.4v1.2c-.2 13.1 3.7 25.2 10.4 35.2l14.2-10.5z",
    className: "colorcce9ff svgShape"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB9678",
    d: "m245.6 213.4-10.1-15c-6.6 4.9-14.6 7.7-23.2 7.5-13.1-.2-24.6-7.1-31.6-17.5L166.4 199c.6 1 1.3 1.9 2 2.8 9.6 12.7 22.6 20.3 37.9 22.1h.3c.8.1 1.6.2 2.3.2H209.7c.8 0 1.6.1 2.4.1 12.2.2 23.6-3.7 33-10.5 1.1-.7 1.4-1 .5-.3z",
    className: "colorffbe55 svgShape"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#25B39E",
    d: "m213.9 163.9 61.9 21c11.1-35.8-7.6-74.2-41.8-85.8-6.8-2.3-12.9-3.3-20.1-3.3v68.1z",
    className: "color2a94f4 svgShape"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB9678",
    d: "m717.8 217-.3-14.8-12.6-.8c-1-4.8-2.8-9.3-5.2-13.3l8.2-10.5-10.2-10.2-9.4 8.7c-3.8-2.6-8.1-4.5-12.7-5.5l-1.3-13.5-14.1.3-.8 13.1c-4.6 1-8.9 2.9-12.7 5.5l-10.1-8.5-9.8 10.7 8.3 9.9c-2.5 4-4.3 8.5-5.3 13.3l-12.9 1.4.3 14.8 12.6.8c1 4.8 2.8 9.3 5.2 13.3l-8.2 10.5 10.2 10.2 9.4-8.7c3.8 2.6 8.1 4.5 12.7 5.5l1.3 13.5 14.1-.3.8-13.1c4.6-1 8.9-2.9 12.7-5.5l10.1 8.5 9.8-10.7-8.3-9.9c2.5-4 4.3-8.5 5.3-13.3l12.9-1.4zm-50 12.3c-10.3.2-18.8-8.3-19-19.1-.2-10.8 7.9-19.7 18.2-19.9 10.3-.2 18.8 8.3 19 19.1.3 10.7-7.9 19.6-18.2 19.9z",
    className: "colorffbe55 svgShape"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbe55",
    d: "m665.7 219.4-6-6.3 3.2-3.3 2.8 3 9.6-10 3.1 3.3z",
    className: "colorffbe55 svgShape"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.4c25084cd0e3815aad331f7ea9addaf2.svg";
export { ForwardRef as ReactComponent };